import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import React, { useEffect, useState, useContext } from "react";
import { UserInfoContext } from "../../service/UserInfoContext";
import { getListaComprobantes } from "../../service/service";
import { makeStyles } from '@mui/styles';

import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Table from '@mui/material/Table';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ClearIcon from '@mui/icons-material/Clear';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { es } from 'date-fns/locale'
import { addMonths, format } from 'date-fns';
import { useLocation } from "react-router-dom";
import logoenvaco from "../../assets/img/logoenvaco.png";
import pyocomovosLogo from "../../assets/img/pyocomovos.png";
import marcapaispyLogo from "../../assets/img/marcapaispy.png";
import sgsisoLogo from "../../assets/img/sgsiso.png";
import esEmpresaBcertificadaLogo from "../../assets/img/esempresabcertificada.png";


/* estilos que se aplican a la tabla */
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

/* columnas de la tabla */
const baseColumnsDefault = [
  { id: 'numeroComprobante', label: 'Nro. Documento', minWidth: 170 },
  { id: 'tipoComprobante', label: 'Tipo Documento', minWidth: 170, align: 'center', },
  {
    id: 'fecha',
    label: 'Fecha',
    minWidth: 170,
    align: 'center',
  },
  {
    id: 'bl',
    label: 'B/L',
    minWidth: 170,
    align: 'center',
  },
  {
    id: 'total',
    label: 'Total',
    minWidth: 170,
    align: 'center',
  },
];


const currentOrigin = window.location.origin;
const isEnvaco = currentOrigin.includes("envaco");
const isCraft = currentOrigin.includes("craft");

const baseColumns = isEnvaco
  ? [
      { ...baseColumnsDefault[2], minWidth: 280 },
      baseColumnsDefault[0],
      baseColumnsDefault[1],
      { ...baseColumnsDefault[3], minWidth: 130 },
      { ...baseColumnsDefault[4], minWidth: 130 }
    ]
  : baseColumnsDefault;

// Determinar si se debe ocultar la columna BL
const ocultarBL = !isCraft;
// columnas finales (sin BL si ocultarBL es true)
const columns = ocultarBL
  ? baseColumns.filter(col => col.id !== 'bl')
  : baseColumns;

/** Opciones fijas del filtro "Tipo Documento" (deben coincidir con `tipoComprobante` en los datos). */
const TIPOS_DOCUMENTO_FILTRO = [
  { value: '', label: 'Todos' },
  { value: 'Factura electrónica', label: 'Factura electrónica' },
  { value: 'Autofactura electrónica', label: 'Autofactura electrónica' },
  { value: 'Nota de crédito electrónica', label: 'Nota de crédito electrónica' },
  { value: 'Nota de débito electrónica', label: 'Nota de débito electrónica' },
  { value: 'Nota de remisión electrónica', label: 'Nota de remisión electrónica' },
  { value: 'Recibo de dinero', label: 'Recibo de dinero' },
  { value: 'Documento Firmado', label: 'Documento Firmado' },
];

const useStyles = makeStyles((theme) => ({
  loading: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 9999,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  }
}));

const RangeStepToolbar = ({ toolbarTitle }) => (
  <Box sx={{ px: 2, pt: 2, pb: 1 }}>
    <Typography variant="subtitle2" sx={{ fontWeight: 600, textTransform: 'uppercase' }}>
      {toolbarTitle}
    </Typography>
  </Box>
);

export default function Facturacion({ match, location }) {
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState([]);
  const [rowsBackup, setRowsBackup] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const classes = useStyles();
  const { state } = useContext(UserInfoContext);
  const [filters, setFilters] = useState({}); // Estado para mantener todos los filtros
  const [value, setValue] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [dateRangeError, setDateRangeError] = useState('');
  const [rangePickerOpen, setRangePickerOpen] = useState(false);
  const [rangeSelectionStep, setRangeSelectionStep] = useState('from');
  const [pendingFromDate, setPendingFromDate] = useState(null);
  const [rangePickerView, setRangePickerView] = useState('day');
  let query = useQuery();

  /* se utiliza para dar formato a la fecha a dd/mm/aaaa y proceder a realizar la busqueda */
  const handleChange = (newValue) => {
    setValue(newValue);
    if (newValue) {
      let fechaparse = new Date(newValue).toISOString().substring(0, 10).split('-');
      fechaparse = `${fechaparse[2]}/${fechaparse[1]}/${fechaparse[0]}`;
      updateFilter('fecha', fechaparse);
    } else {
      updateFilter('fecha', null);
    }
  };


  const parseDateString = (dateString) => {
    if (!dateString || typeof dateString !== 'string') return null;
    const parts = dateString.split('/');
    if (parts.length !== 3) return null;

    const day = Number(parts[0]);
    const month = Number(parts[1]) - 1;
    const year = Number(parts[2]);
    const parsed = new Date(year, month, day);

    if (
      Number.isNaN(parsed.getTime()) ||
      parsed.getDate() !== day ||
      parsed.getMonth() !== month ||
      parsed.getFullYear() !== year
    ) {
      return null;
    }

    return parsed;
  };

  /* paginado */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  /* se obtiene la lista de comprobantes, una vez que se encuentren los datos de idEmpresa y ruc */
  useEffect(() => {
    let ruc = query.get("ruc");
    if (state?.idEmpresa !== undefined && state?.ruc !== undefined) {
      if (ruc !== null) {
        if(ruc === '0'){
          obtenerListado(state.idEmpresa, null);
        } else{
          obtenerListado(state.idEmpresa, ruc);
        }
        
      } else {
        obtenerListado(state.idEmpresa, state.ruc);
      }

    }
  }, []);

  const obtenerListado = (idEmpresa, ruc) => {
    setLoading(true);
    getListaComprobantes(idEmpresa, ruc).then(response => {
      setLoading(false);
      setRows(response.data);
      setRowsBackup(response.data);
    }).catch(error => {
      setLoading(false);
      console.error(error);
    })
  }
  
  const download = (data) => {
    setLoading(true);
    fetch(data.pdfLink).then(response => {
      response.blob().then(blob => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = data.numeroComprobante;
        alink.click();
        setLoading(false);
      })
    })
  }

  /* actualizar un filtro específico y aplicar todos los filtros */
  const updateFilter = (key, value) => {
    const newFilters = { ...filters };
    if (value !== '' && value !== null && value !== undefined) {
      // Guardar el valor sin trim para permitir espacios mientras el usuario escribe
      newFilters[key] = value.toString();
    } else {
      delete newFilters[key];
    }
    setFilters(newFilters);
    applyFilters(newFilters);
  }

  /* aplicar todos los filtros sobre rowsBackup */
  const applyFilters = (filtersToApply) => {
    const [fechaDesde, fechaHasta] = dateRange;

    if (Object.keys(filtersToApply).length === 0 && (!isEnvaco || (!fechaDesde && !fechaHasta))) {
      setRows(rowsBackup);
      setPage(0);
      return;
    }

    const hasPartialRange = (fechaDesde && !fechaHasta) || (!fechaDesde && fechaHasta);
    const hasCompleteRange = fechaDesde && fechaHasta;
    let validRange = true;

    if (hasPartialRange) {
      // Mientras se selecciona el rango, no mostrar error.
      setDateRangeError('');
      validRange = false;
    } else if (hasCompleteRange && fechaDesde > fechaHasta) {
      setDateRangeError('La Fecha desde no puede ser mayor a la Fecha hasta.');
      validRange = false;
    } else if (hasCompleteRange && fechaHasta > addMonths(fechaDesde, 1)) {
      setDateRangeError('El rango no puede superar 1 mes.');
      validRange = false;
    } else {
      setDateRangeError('');
    }

    let result = rowsBackup.filter(obj => {
      const matchesTextFilters = Object.keys(filtersToApply).every(key => {
        // Aplicar trim solo al comparar, no al guardar el valor
        const filterValue = filtersToApply[key].trim().toLowerCase();
        const field = obj[key];
        
        if (field === null || field === undefined) {
          return filterValue === '';
        }

        return field.toString().trim().toLowerCase() === filterValue;
      });

      if (!matchesTextFilters) return false;
      if (!isEnvaco) return true;
      if (!hasCompleteRange || !validRange) return true;

      const rowDate = parseDateString(obj.fecha);
      if (!rowDate) return false;

      return rowDate >= fechaDesde && rowDate <= fechaHasta;
    });
    
    setRows(result);
    setPage(0); // Resetear a la primera página cuando se aplica un filtro
  }

  /* función legacy para mantener compatibilidad */
  const search = (key, value) => {
    updateFilter(key, value);
  }

  useEffect(() => {
    if (isEnvaco) {
      applyFilters(filters);
    }
  }, [dateRange, rowsBackup]);


  const onKeyDown = (e) => {
    e.preventDefault();
  };
  const selectingHasta = rangeSelectionStep === 'to';

  const handleEnvacoRangeSelection = (selectedDate) => {
    if (!selectedDate) return;
    if (rangePickerView !== 'day') return;

    if (rangeSelectionStep === 'from') {
      setPendingFromDate(selectedDate);
      setDateRangeError('');
      setRangeSelectionStep('to');
      setRangePickerOpen(true);
      return;
    }

    setDateRange([pendingFromDate, selectedDate]);
    setPendingFromDate(null);
    setRangeSelectionStep('from');
    setRangePickerOpen(false);
  };

  return (
    <>
      <Container style={{ marginTop: '5em' }}>
        <div className='container'>
          {loading &&
            <div className={classes.loading}>
              <CircularProgress size={60} />
            </div>
          }
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: 2,
              gap: 2
            }}
          >
            <Box>
              <Typography variant="title"><span style={{ fontWeight: 100 }}></span> {state?.nombreCompleto}</Typography>
              <Typography variant="h6" component="div">
                Éstos son tus documentos
              </Typography>
            </Box>
            {isEnvaco && (
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: 'repeat(3, auto)', md: 'repeat(5, auto)' },
                  justifyContent: { xs: 'end', md: 'start' },
                  alignItems: 'center',
                  gap: 1.2
                }}
              >
                <Box
                  component="img"
                  src={logoenvaco}
                  alt="Logo Envaco"
                  sx={{
                    width: { xs: 72, md: 90 },
                    height: 'auto',
                    objectFit: 'contain',
                    mixBlendMode: 'multiply'
                  }}
                />
                <Box
                  component="img"
                  src={pyocomovosLogo}
                  alt="Py Como Vos"
                  sx={{ width: { xs: 34, md: 42 }, height: 'auto', objectFit: 'contain' }}
                />
                <Box
                  component="img"
                  src={marcapaispyLogo}
                  alt="Marca País Paraguay"
                  sx={{ width: { xs: 34, md: 42 }, height: 'auto', objectFit: 'contain' }}
                />
                <Box
                  component="img"
                  src={sgsisoLogo}
                  alt="SGS ISO"
                  sx={{
                    width: { xs: 34, md: 42 },
                    height: 'auto',
                    objectFit: 'contain',
                    gridColumn: { xs: '2', md: 'auto' }
                  }}
                />
                <Box
                  component="img"
                  src={esEmpresaBcertificadaLogo}
                  alt="Es Empresa B Certificada"
                  sx={{
                    width: { xs: 34, md: 42 },
                    height: 'auto',
                    objectFit: 'contain',
                    filter: 'brightness(0)'
                  }}
                />
              </Box>
            )}
          </Box>

          <Paper elevation={24} sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 900 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <StyledTableCell
                        key={column.id}
                        align="center"
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </StyledTableCell>
                    ))}
                    <StyledTableCell
                      key="action-header"
                      align="center"
                      style={{ minWidth: 170 }}
                    >
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    {columns.map((column, index) => (
                      <TableCell key={`search-${column.id}`} align="center">
                        {column.id === 'fecha' && (
                          <LocalizationProvider adapterLocale={es} dateAdapter={AdapterDateFns}>
                            {isEnvaco ? (
                              <div style={{ display: "flex", justifyContent: "center" }}>
                                <div style={{ position: "relative", display: "inline-block" }}>
                                  <TextField
                                    onKeyDown={onKeyDown}
                                    variant="standard"
                                    label="Buscar por rango de fecha"
                                    value={
                                      dateRange[0] && dateRange[1]
                                        ? `${format(dateRange[0], 'dd/MM/yyyy')} a ${format(dateRange[1], 'dd/MM/yyyy')}`
                                          : ''
                                    }
                                    helperText={dateRangeError}
                                    FormHelperTextProps={{
                                      sx: { color: 'error.main' }
                                    }}
                                    placeholder="dd/mm/yyyy a dd/mm/yyyy"
                                    sx={{
                                      minWidth: 280,
                                        '& .MuiInputBase-root': {
                                          paddingRight: '6px',
                                          height: '33px'
                                        }
                                    }}
                                    InputLabelProps={{
                                      sx: { fontSize: '0.85rem' },
                                      shrink: Boolean(dateRange[0] && dateRange[1])
                                    }}
                                    InputProps={{
                                      readOnly: true,
                                      endAdornment: (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                          {(dateRange[0] || dateRange[1]) && (
                                            <IconButton
                                              onClick={() => {
                                                setDateRange([null, null]);
                                                setPendingFromDate(null);
                                                setDateRangeError('');
                                                setRangeSelectionStep('from');
                                                setRangePickerOpen(false);
                                              }}
                                            >
                                              <ClearIcon />
                                            </IconButton>
                                          )}
                                          <IconButton
                                            onClick={() => {
                                              setRangeSelectionStep('from');
                                              setPendingFromDate(null);
                                              setRangePickerView('day');
                                              setRangePickerOpen(true);
                                            }}
                                          >
                                            <CalendarTodayOutlinedIcon />
                                          </IconButton>
                                        </div>
                                      ),
                                    }}
                                  />
                                  <DatePicker
                                    value={selectingHasta ? pendingFromDate : null}
                                    onChange={handleEnvacoRangeSelection}
                                    onViewChange={(newView) => setRangePickerView(newView)}
                                    open={rangePickerOpen}
                                    onClose={() => {
                                      setRangePickerOpen(false);
                                      setRangePickerView('day');
                                    }}
                                    closeOnSelect={selectingHasta}
                                    openTo="day"
                                    PopperProps={{ placement: 'bottom-start' }}
                                    componentsProps={{
                                      popper: { placement: 'bottom-start' }
                                    }}
                                    showToolbar
                                    toolbarTitle={selectingHasta ? 'Fecha hasta' : 'Fecha desde'}
                                    ToolbarComponent={RangeStepToolbar}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        sx={{
                                          position: 'absolute',
                                          top: 0,
                                          left: 0,
                                          width: '1px',
                                          opacity: 0,
                                          pointerEvents: 'none'
                                        }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            ) : (
                              <DatePicker
                                label="Buscar Fecha"
                                inputFormat="dd/MM/yyyy"
                                value={value}
                                onChange={handleChange}
                                renderInput={(params) => (
                                  <div style={{ position: "relative", display: "inline-block" }}>
                                    <TextField onKeyDown={onKeyDown} variant="standard" {...params} />
                                    <IconButton
                                      style={{ position: "absolute", top: "0.9rem", margin: "auto", right: "2rem" }}
                                      onClick={() => {
                                        setValue(null);
                                        updateFilter('fecha', null);
                                      }}
                                    >
                                      <ClearIcon />
                                    </IconButton>
                                  </div>
                                )}
                              />
                            )}
                          </LocalizationProvider>
                        )}
                        {column.id === 'tipoComprobante' && (
                          <FormControl fullWidth variant="standard">
                            <InputLabel id="tipo-comprobante-filter-label">Tipo Documento</InputLabel>
                            <Select
                              labelId="tipo-comprobante-filter-label"
                              value={filters[column.id] || ''}
                              onChange={(ev) => {
                                updateFilter(column.id, ev.target.value);
                              }}
                            >
                              {TIPOS_DOCUMENTO_FILTRO.map((option) => (
                                <MenuItem key={option.value || 'todos'} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        )}
                        {column.id !== 'fecha' && column.id !== 'tipoComprobante' && (
                          <TextField 
                            id={`standard-basic-${index}`} 
                            label={`Buscar ${column.label}`} 
                            variant="standard"
                            value={filters[column.id] || ''}
                            InputLabelProps={isEnvaco ? { sx: { fontSize: '0.85rem' } } : undefined}
                            onChange={(ev) => {
                              updateFilter(column.id, ev.target.value);
                            }}
                            onKeyPress={(ev) => {
                              if (ev.key === 'Enter') {
                                ev.preventDefault();
                              }
                            }} 
                          />
                        )}
                      </TableCell>
                    ))}
                    <TableCell key="search-actions" align="center"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.length > 0 ? (
                    rows
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, rowIndex) => {
                        return (
                          <TableRow hover tabIndex={-1} key={`${row.numeroComprobante}-${row.tipoComprobante}-${row.fecha}-${rowIndex}`}>
                            {columns.map((column) => (
                              <TableCell key={column.id} align="center" style={{ fontWeight: 300 }}>
                                {row[column.id]}
                              </TableCell>
                            ))}
                            <TableCell align="center" style={{ fontWeight: 300 }}>
                              <Button 
                                variant="contained" 
                                color="secondary" 
                                endIcon={<LocalPrintshopIcon />} 
                                onClick={() => download(row)}
                              >
                                Descargar
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} align="center">
                        No se encontraron registros.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={"Registros por página"}
              labelDisplayedRows={
                ({ from, to, count }) => {
                  return '' + from + '-' + to + ' de ' + count
                }
              }
            />
          </Paper>
        </div>
      </Container>
    </>
  )
}

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}